/*
  PTIE-496 + PTIE-495 : Search suggestions panel
  ----------------------------------------------
  Ek hi dropdown panel jismein do groups hote hain:

    1. Recent searches (PTIE-496) -- user ki apni history, localStorage se,
       runtime par JS inject karta hai.
    2. Top searches (PTIE-495)    -- merchant ke set kiye terms, Liquid se
       static render hote hain, JS ko inhein touch nahi karna.

  Ye file purani recent-searches.js ko REPLACE karti hai. Dono groups ek hi
  absolutely-positioned panel mein hone chahiye warna woh ek doosre ke upar
  chad jate hain.

  Markup (header.liquid / header-search.liquid):
    [data-search-suggestions]     -> panel wrapper (Liquid `hidden` ke sath)
    [data-recent-searches]        -> recent group (sirf tab jab toggle ON ho)
    [data-recent-searches-list]   -> <ul> jismein history inject hoti hai
    [data-recent-searches-clear]  -> optional clear button

  Panel kab khulta hai: khali search input par click/focus.
  Panel kab band hota hai: typing, submit, bahar click, Escape.
*/

(function () {
  'use strict';

  var STORAGE_KEY = 'theme:recent-searches';
  var DEFAULT_LIMIT = 5;

  /* ---------- storage (private mode mein throw kar sakta hai) ---------- */

  function readTerms() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];

      if (!Array.isArray(list)) return [];

      return list.filter(function (term) {
        return typeof term === 'string' && term.trim() !== '';
      });
    } catch (error) {
      return [];
    }
  }

  function writeTerms(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (error) {
      /* quota / disabled storage -- chup chaap ignore */
    }
  }

  function addTerm(term, limit) {
    term = (term || '').trim();
    if (!term) return;

    var list = readTerms().filter(function (item) {
      return item.toLowerCase() !== term.toLowerCase();
    });

    list.unshift(term);
    writeTerms(list.slice(0, limit));
  }

  /* ---------- helpers ---------- */

  function buildSearchUrl(base, term) {
    return base + '?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
  }

  function recentGroupOf(panel) {
    return panel.querySelector('[data-recent-searches]');
  }

  function limitOf(group) {
    return parseInt(group.getAttribute('data-recent-searches-limit'), 10) || DEFAULT_LIMIT;
  }

  function baseOf(group) {
    return group.getAttribute('data-recent-searches-url') || '/search';
  }

  // Top searches jaise static groups -- inhe JS render nahi karta
  function hasStaticGroups(panel) {
    return panel.querySelector('[data-static-group]') !== null;
  }

  /* ---------- render ---------- */

  function renderRecent(panel) {
    var group = recentGroupOf(panel);
    if (!group) return 0;

    var listEl = group.querySelector('[data-recent-searches-list]');
    if (!listEl) return 0;

    var terms = readTerms();
    var base = baseOf(group);

    listEl.innerHTML = '';

    terms.forEach(function (term) {
      var item = document.createElement('li');
      item.className = 'search-suggestions__item';

      var link = document.createElement('a');
      link.className = 'search-suggestions__link';
      link.href = buildSearchUrl(base, term);
      link.textContent = term; // textContent -> XSS safe

      item.appendChild(link);
      listEl.appendChild(item);
    });

    // history khali ho to sirf ye group chhupao, poora panel nahi
    if (terms.length) {
      group.removeAttribute('hidden');
    } else {
      group.setAttribute('hidden', '');
    }

    return terms.length;
  }

  /* ---------- visibility ---------- */

  function setVisible(panel, visible) {
    var recentCount = renderRecent(panel);
    var hasSomething = recentCount > 0 || hasStaticGroups(panel);

    if (visible && hasSomething) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  }

  /* ---------- wiring ---------- */

  function setup(panel) {
    var form = panel.closest('form');
    if (!form) return;

    var input = form.querySelector('input[type="search"]');
    if (!input) return;

    var group = recentGroupOf(panel);
    var limit = group ? limitOf(group) : DEFAULT_LIMIT;

    renderRecent(panel);

    function openIfEmpty() {
      if (input.value.trim() !== '') return;
      setVisible(panel, true);
    }

    // focus: pehli dafa click ya keyboard tab se aane par
    input.addEventListener('focus', openIfEmpty);
    // click: input pehle se focused ho (Escape ke baad dobara click) tab focus fire nahi hota
    input.addEventListener('click', openIfEmpty);

    // type karte hi predictive results le lete hain -> panel hide
    // sab text delete kar dein to wapas show ho jata hai
    input.addEventListener('input', function () {
      setVisible(panel, input.value.trim() === '');
    });

    // reset button par input khali ho jata hai lekin `input` event nahi chalta
    form.addEventListener('reset', function () {
      window.setTimeout(function () {
        setVisible(panel, document.activeElement === input);
      }, 0);
    });

    form.addEventListener('submit', function () {
      if (group) addTerm(input.value, limit);
      setVisible(panel, false);
    });

    if (group) {
      var clearButton = group.querySelector('[data-recent-searches-clear]');

      if (clearButton) {
        clearButton.addEventListener('click', function () {
          writeTerms([]);
          // top searches abhi bhi ho sakti hain -> panel khula reh sakta hai
          setVisible(panel, true);
          input.focus();
        });
      }
    }

    document.addEventListener('click', function (event) {
      if (!form.contains(event.target)) setVisible(panel, false);
    });

    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape') setVisible(panel, false);
    });
  }

  // /search?q=... par land hue -> term save kar lo
  // isse woh searches bhi history mein aati hain jo predictive suggestion
  // par click kar ke hui thin
  function captureFromUrl(panel) {
    var group = recentGroupOf(panel);
    if (!group) return;

    try {
      var term = new URLSearchParams(window.location.search).get('q');
      if (!term) return;
      if (window.location.pathname.indexOf(baseOf(group)) === -1) return;

      addTerm(term, limitOf(group));
    } catch (error) {
      /* purane browsers mein URLSearchParams na ho -> skip */
    }
  }

  function init() {
    var panels = document.querySelectorAll('[data-search-suggestions]');
    if (!panels.length) return;

    captureFromUrl(panels[0]);
    panels.forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // theme editor mein header dobara render hone par
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-search-suggestions]').forEach(setup);
  });
})();